/* eslint-disable @typescript-eslint/member-ordering */
import {
  Component,
  ViewChild,
  EventEmitter,
  Output,
  OnInit,
  AfterViewInit,
  Input,
  ElementRef,
} from '@angular/core';
import { IonSearchbar } from '@ionic/angular';
declare var google: any; // Declare the google object

@Component({
  selector: 'dynamic-address-input',
  templateUrl: './dynamic-address-input.component.html',
  styleUrls: ['./dynamic-address-input.component.scss'],
})
export class DynamicAddressInputComponent implements OnInit, AfterViewInit {
  @Input()
  adressType!: string;
  @Output() setAddress: EventEmitter<any> = new EventEmitter();
  @ViewChild('addresstext', { read: IonSearchbar })
  addresstext!: IonSearchbar;

  autocompleteInput!: string;
  queryWait!: boolean;

  constructor() {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.getPlaceAutocomplete();
  }

  private async getPlaceAutocomplete() {
    const addressElement = await this.addresstext.getInputElement();
    if (typeof google !== 'undefined') {
      const autocomplete = new google.maps.places.Autocomplete(addressElement, {
        types: [this.adressType], // 'establishment' / 'address' / 'geocode'
      });  
      google.maps.event.addListener(autocomplete, 'place_changed', () => {
        const place = autocomplete.getPlace();
        this.invokeEvent(place);
      });
    }
  }

  invokeEvent(place: Object) {
    this.setAddress.emit(place);
  }
  resetInput() {
    this.addresstext.value = '';
  }
}
